import PropTypes from "prop-types";
import React, { lazy, useEffect } from "react";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import { Navigate, Outlet, useLocation, useRoutes } from "react-router-dom";
import FooterLoggedInOut from "./FooterLoggedInOut";
import HeaderLoggedIn from "./HeaderLoggedIn";
import HeaderLoggedOut from "./HeaderLoggedOut";
const Home = lazy(() => import("./subcomponents/home/Home.js"));
const Manager = lazy(() => import("./subcomponents/manager/Manager.js"));
const Notification = lazy(() => import("./subcomponents/home/Notification.js"));
const Profile = lazy(() => import("./subcomponents/home/Profile.js"));
const ProjectView = lazy(() => import("./subcomponents/proj/ProjectView.js"));
const Project = lazy(() => import("./subcomponents/proj/Project.js"));
const Item = lazy(() => import("./subcomponents/item/Item.js"));
const Logout = lazy(() => import("./subcomponents/auth/Logout.js"));
const Login = lazy(() => import("./subcomponents/auth/Login.js"));
const GoogleOauth = lazy(() => import("./subcomponents/auth/GoogleOauth.js"));
const MicrosoftOauth = lazy(() =>
  import("./subcomponents/auth/MicrosoftOauth.js")
);
const MicrosoftSync = lazy(() =>
  import("./subcomponents/auth/MicrosoftSync.js")
);

const CRM = lazy(() => import("./subcomponents/crm/CRM.js"));
const GoogleCode = lazy(() => import("./subcomponents/home/GoogleCode.js"));
const GoogleToken = lazy(() => import("./subcomponents/home/GoogleToken.js"));

const Register = lazy(() => import("./subcomponents/auth/Register.js"));
const Administration = lazy(() =>
  import("./subcomponents/home/Administration")
);
const Pricing = lazy(() => import("./subcomponents/home/Pricing.js"));
const Error404 = lazy(() => import("./subcomponents/about/Error404"));

const Contact = lazy(() => import("./subcomponents/about/Contact.js"));

const EmailValidation = lazy(() =>
  import("./subcomponents/emailValidation/EmailValidation.js")
);
const ResendEmailValidation = lazy(() =>
  import("./subcomponents/emailValidation/ResendEmailValidation.js")
);
const ResetPassword = lazy(() => import("./subcomponents/auth/ResetPassword"));
const DefinePassword = lazy(() =>
  import("./subcomponents/auth/DefinePassword")
);
// const ResourcePlanning = lazy(() => import("./subcomponents/item/Item.js"));

function usePageViews(acceptCookies) {
  const location = useLocation();
  useEffect(() => {
    if (acceptCookies === true) {
      ReactGA.set({ page: location.pathname + location.search });
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [location]);
}

const Pages = (props) => {
  // props.history.listen((location, action) => {
  //   console.log("location pathname", location.pathname);
  //   // if (location.pathname !== this.state.location) {
  //   ReactGA.set({ page: location.pathname });
  //   ReactGA.pageview(location.pathname);
  //   this.setState({ location: location.pathname });
  //   // }
  // });
  let propTypes = {
    checkAuthentification: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    accept: PropTypes.bool,
    acceptCookies: PropTypes.bool,
  };

  usePageViews(props.acceptCookies);

  // if (isAuthenticated) {
  // const Loading = (

  //   <div style={{ fontSize: "24px" }}>
  //     <div style={{ width: "50px" }}>
  //       <Spinner />
  //     </div>
  //   </div>
  // );
  //   console.log("pages");
  //   ReactGA.pageview(window.location.pathname + window.location.search);
  // }

  //Logged ou

  const LoginElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedOut props={props} />
      {props.isAuthenticated ? <Navigate to="/projects" /> : <Login />}
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const GoogleOauthElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedOut props={props} />
      {props.isAuthenticated ? <Navigate to="/projects" /> : <GoogleOauth />}
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const GoogleCalendarElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <GoogleCode /> : <Navigate to="/login" />}
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const GoogleTokenElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <GoogleToken /> : <Navigate to="/login" />}
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const MicrosoftOauthElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedOut props={props} />
      {props.isAuthenticated ? <Navigate to="/projects" /> : <MicrosoftOauth />}
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const RegisterElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedOut props={props} />
      {props.isAuthenticated ? <Navigate to="/projects" /> : <Register />}
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const PricingElement = (
    <React.Suspense fallback={<>Loading...</>}>
      {props.isAuthenticated ? (
        <HeaderLoggedIn props={props} />
      ) : (
        <HeaderLoggedOut props={props} />
      )}
      <Pricing />
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const ResendEmailValidationElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedOut props={props} />
      {props.isAuthenticated ? (
        <Navigate to="/projects" />
      ) : (
        <ResendEmailValidation />
      )}
      <FooterLoggedInOut />
    </React.Suspense>
  );

  //Logged in
  const LogoutElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <Logout /> : <Navigate to="/login" />}
      {props.footer ? <FooterLoggedInOut /> : null}
    </React.Suspense>
  );

  const HomeElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <Home /> : <Navigate to="/login" />}
      {/* <FooterLoggedInOut /> */}
    </React.Suspense>
  );

  const CRMElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <CRM /> : <Navigate to="/login" />}
      {/* <FooterLoggedInOut /> */}
    </React.Suspense>
  );

  const ManagerElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <Manager /> : <Navigate to="/login" />}
      {/* <FooterLoggedInOut /> */}
    </React.Suspense>
  );

  const NotificationElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <Notification /> : <Navigate to="/login" />}
      {props.footer ? <FooterLoggedInOut /> : null}
    </React.Suspense>
  );

  const ProjectsElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <ProjectView /> : <Navigate to="/login" />}
      {/* {props.footer ? <FooterLoggedInOut /> : null} */}
    </React.Suspense>
  );

  const ProjectElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <Project /> : <Navigate to="/login" />}
      {/* {props.footer ? <FooterLoggedInOut /> : null} */}
    </React.Suspense>
  );

  const ProfileElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <Profile /> : <Navigate to="/login" />}
      {/* {props.footer ? <FooterLoggedInOut /> : null} */}
    </React.Suspense>
  );

  const ItemElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <Item /> : <Navigate to="/login" />}
      {/* {props.footer ? <FooterLoggedInOut /> : null} */}
    </React.Suspense>
  );

  const AdministrationElement = (
    <React.Suspense fallback={<>Loading...</>}>
      <HeaderLoggedIn props={props} />
      {props.isAuthenticated ? <Administration /> : <Navigate to="/login" />}
      {/* {props.footer ? <FooterLoggedInOut /> : null} */}
    </React.Suspense>
  );

  // const ResourcePlanningElement = (
  //   <React.Suspense fallback={<>Loading...</>}>
  //     <HeaderLoggedIn props={props} />
  //     {props.isAuthenticated ? <ResourcePlanning /> : <Navigate to="/login" />}
  //     {props.footer ? <FooterLoggedInOut /> : null}
  //   </React.Suspense>
  // );

  const MicrosoftSyncElement = (
    <React.Suspense fallback={<>Loading...</>}>
      {/* {props.isAuthenticated ? ( */}
      {/* <HeaderLoggedIn props={props} /> */}
      {/* ) : ( */}
      <HeaderLoggedOut props={props} />

      <MicrosoftSync />
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const ContactElement = (
    <React.Suspense fallback={<>Loading...</>}>
      {props.isAuthenticated ? (
        <HeaderLoggedIn props={props} />
      ) : (
        <HeaderLoggedOut props={props} />
      )}
      <Contact />
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const DefinePasswordElement = (
    <React.Suspense fallback={<>Loading...</>}>
      {props.isAuthenticated ? (
        <HeaderLoggedIn props={props} />
      ) : (
        <HeaderLoggedOut props={props} />
      )}
      <DefinePassword />
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const ResetPasswordElement = (
    <React.Suspense fallback={<>Loading...</>}>
      {props.isAuthenticated ? (
        <HeaderLoggedIn props={props} />
      ) : (
        <HeaderLoggedOut props={props} />
      )}
      <ResetPassword />
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const EmailValidationElement = (
    <React.Suspense fallback={<>Loading...</>}>
      {props.isAuthenticated ? (
        <HeaderLoggedIn props={props} />
      ) : (
        <HeaderLoggedOut props={props} />
      )}
      <EmailValidation />
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const Layout = () => (
    <div>
      <Outlet />
    </div>
  );

  const Error404Page = (
    <React.Suspense fallback={<>Loading...</>}>
      {props.isAuthenticated ? (
        <HeaderLoggedIn props={props} />
      ) : (
        <HeaderLoggedOut props={props} />
      )}
      <Error404 />
      <FooterLoggedInOut />
    </React.Suspense>
  );

  const routes = [
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: LoginElement },
        { path: "/en", element: LoginElement },
        { path: "/fr", element: LoginElement },
        { path: "/de", element: LoginElement },
        { path: "/en/login", element: LoginElement },
        { path: "/en/googleoauthLogin", element: GoogleOauthElement },
        { path: "/en/googleoauthRegister", element: GoogleOauthElement },
        { path: "/en/microsoftoauth", element: MicrosoftOauthElement },
        // { path: "/en/microsoftSync", element: MicrosoftSyncElement },
        { path: "/en/register", element: RegisterElement },

        // { path: "/en/pricing", element: PricingElement },
        {
          path: "/en/resendEmailValidation",
          element: ResendEmailValidationElement,
        },
        { path: "/en/contact", element: ContactElement },
        { path: "/en/definePassword", element: DefinePasswordElement },
        { path: "/fr/login", element: LoginElement },
        { path: "/fr/googleoauthLogin", element: GoogleOauthElement },
        { path: "/fr/googleoauthRegister", element: GoogleOauthElement },
        { path: "/fr/microsoftoauth", element: MicrosoftOauthElement },
        // { path: "/fr/microsoftSync", element: MicrosoftSyncElement },
        { path: "/fr/register", element: RegisterElement },
        // { path: "/fr/pricing", element: PricingElement },
        {
          path: "/fr/resendEmailValidation",
          element: ResendEmailValidationElement,
        },
        { path: "/fr/contact", element: ContactElement },
        { path: "/fr/definePassword", element: DefinePasswordElement },
        { path: "/de/login", element: LoginElement },
        { path: "/de/googleoauthLogin", element: GoogleOauthElement },
        { path: "/de/googleoauthRegister", element: GoogleOauthElement },
        { path: "/de/microsoftoauth", element: MicrosoftOauthElement },
        // { path: "/de/microsoftSync", element: MicrosoftSyncElement },
        { path: "/de/register", element: RegisterElement },
        // { path: "/de/pricing", element: PricingElement },
        {
          path: "/de/resendEmailValidation",
          element: ResendEmailValidationElement,
        },
        { path: "/de/contact", element: ContactElement },
        { path: "/de/definePassword", element: DefinePasswordElement },
        {
          path: "/login",
          element: LoginElement,
        },
        { path: "/googleoauthLogin", element: GoogleOauthElement },
        { path: "/googleoauthRegister", element: GoogleOauthElement },
        { path: "/microsoftoauth", element: MicrosoftOauthElement },
        { path: "/microsoftSync", element: MicrosoftSyncElement },
        {
          path: "/register",
          element: RegisterElement,
        },
        {
          path: "/crm",
          element: CRMElement,
        },
        {
          path: "/pricing",
          element: PricingElement,
        },
        {
          path: "/resendEmailValidation",
          element: ResendEmailValidationElement,
        },
        {
          path: "/logout",
          element: LogoutElement,
        },
        {
          path: "/home",
          element: HomeElement,
        },
        {
          path: "/manager",
          element: ManagerElement,
        },
        {
          path: "/notification",
          element: NotificationElement,
        },
        {
          path: "/projects",
          element: ProjectsElement,
        },
        {
          path: "/project",
          element: ProjectElement,
        },
        {
          path: "/profile",
          element: ProfileElement,
        },
        { path: "/googleCalendar", element: GoogleCalendarElement },
        { path: "/googleToken", element: GoogleTokenElement },
        {
          path: "/item",
          element: ItemElement,
        },
        {
          path: "/administration",
          element: AdministrationElement,
        },
        // {
        //   path: "/resourceplanning",
        //   element: ResourcePlanningElement,
        // },
        {
          path: "/contact",
          element: Contact,
        },
        {
          path: "/definePassword",
          element: DefinePasswordElement,
        },
        {
          path: "/resetPassword/:id",
          element: ResetPasswordElement,
        },
        {
          path: "/emailValidation/:id",
          element: EmailValidationElement,
        },
      ],
    },
    {
      path: "*",
      element: Error404Page,
    },
  ];

  return useRoutes(routes);
};
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  footer: state.page.footer,
  acceptCookies: state.auth.acceptCookies,
});
export default connect(mapStateToProps, {})(Pages);
